import { Search } from "./search.model";

export const processSearchData = (
  response: any[] = [],
  headerObj: any,
  isScroll = false
) => {
  const searchData = response.map((res) => new Search(res, headerObj));
  headerObj.data = isScroll
    ? [...(headerObj.data ?? []), ...searchData]
    : searchData;
  headerObj.response = isScroll
    ? [...(headerObj.response ?? []), ...response]
    : response;
  return headerObj;
};

export const isResultNotAvailalable = (headers: any[]) => {
  let dataAvailable = false;
  let invalid_regex = true;

  headers.forEach((header) => {
    if (header?.response !== null) {
      invalid_regex = false;
      if (header?.response.length > 0) dataAvailable = true;
    }
  });

  return { dataAvailable, invalid_regex };
};
